import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Dropdown } from "react-bootstrap";
import { logout } from "../../helper/helper"
import { BASE_URL } from "../../env";
import { Link, useNavigate } from "react-router-dom";

function ProfileDropdown() {
  const loggedInUserDetails = localStorage.getItem("userLoggedInDetails");
  const userDetails = JSON.parse(loggedInUserDetails);
  const navigate = useNavigate();
  const handleTableRowClick = () => {
    navigate("/staff-user-profile");
  };
  return (
    <Dropdown className="profileDropdown">
      <Dropdown.Toggle id="dropdown-basic">
        <img
          src={BASE_URL + userDetails?.profile_picture_url}
          alt={"profilePic"}
        />

        <p>
          {userDetails?.name}
          {/* <small>{userDetails?.role}</small> */}
        </p>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={handleTableRowClick}>Profile</Dropdown.Item>
        <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default ProfileDropdown;
